/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, TextFormat, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { APP_DATE_FORMAT } from 'app/config/constants';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './lab-item-measure.reducer';

export const LabItemMeasure = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const labItemMeasureList = useAppSelector(state => state.labItemMeasure.entities);
  const loading = useAppSelector(state => state.labItemMeasure.loading);
  const totalItems = useAppSelector(state => state.labItemMeasure.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="lab-item-measure-heading" data-cy="LabItemMeasureHeading">
        <Translate contentKey="tinyMedicRestApp.labItemMeasure.home.title">Lab Item Measures</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.labItemMeasure.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/lab-item-measure/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.labItemMeasure.home.createLabel">Create new Lab Item Measure</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.labItemMeasure.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {labItemMeasureList && labItemMeasureList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.labItemMeasure.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('ageMin')}>
                  <Translate contentKey="tinyMedicRestApp.labItemMeasure.ageMin">Age Min</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('ageMin')} />
                </th>
                <th className="hand" onClick={sort('ageMax')}>
                  <Translate contentKey="tinyMedicRestApp.labItemMeasure.ageMax">Age Max</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('ageMax')} />
                </th>
                <th className="hand" onClick={sort('gender')}>
                  <Translate contentKey="tinyMedicRestApp.labItemMeasure.gender">Gender</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('gender')} />
                </th>
                <th className="hand" onClick={sort('weightMin')}>
                  <Translate contentKey="tinyMedicRestApp.labItemMeasure.weightMin">Weight Min</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('weightMin')} />
                </th>
                <th className="hand" onClick={sort('weightMax')}>
                  <Translate contentKey="tinyMedicRestApp.labItemMeasure.weightMax">Weight Max</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('weightMax')} />
                </th>
                <th className="hand" onClick={sort('displayPrecision')}>
                  <Translate contentKey="tinyMedicRestApp.labItemMeasure.displayPrecision">Display Precision</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('displayPrecision')} />
                </th>
                <th className="hand" onClick={sort('hiAbsolute')}>
                  <Translate contentKey="tinyMedicRestApp.labItemMeasure.hiAbsolute">Hi Absolute</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('hiAbsolute')} />
                </th>
                <th className="hand" onClick={sort('hiCritical')}>
                  <Translate contentKey="tinyMedicRestApp.labItemMeasure.hiCritical">Hi Critical</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('hiCritical')} />
                </th>
                <th className="hand" onClick={sort('hiNormal')}>
                  <Translate contentKey="tinyMedicRestApp.labItemMeasure.hiNormal">Hi Normal</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('hiNormal')} />
                </th>
                <th className="hand" onClick={sort('lowAbsolute')}>
                  <Translate contentKey="tinyMedicRestApp.labItemMeasure.lowAbsolute">Low Absolute</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lowAbsolute')} />
                </th>
                <th className="hand" onClick={sort('lowCritical')}>
                  <Translate contentKey="tinyMedicRestApp.labItemMeasure.lowCritical">Low Critical</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lowCritical')} />
                </th>
                <th className="hand" onClick={sort('lowNormal')}>
                  <Translate contentKey="tinyMedicRestApp.labItemMeasure.lowNormal">Low Normal</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lowNormal')} />
                </th>
                <th className="hand" onClick={sort('units')}>
                  <Translate contentKey="tinyMedicRestApp.labItemMeasure.units">Units</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('units')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.labItemMeasure.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.labItemMeasure.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('created')}>
                  <Translate contentKey="tinyMedicRestApp.labItemMeasure.created">Created</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('created')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.labItemMeasure.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.labItemMeasure.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.labItemMeasure.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.labItemMeasure.testItem">Test Item</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.labItemMeasure.diagLab">Diag Lab</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {labItemMeasureList.map((labItemMeasure, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/lab-item-measure/${labItemMeasure.id}`} color="link" size="sm">
                      {labItemMeasure.id}
                    </Button>
                  </td>
                  <td>{labItemMeasure.ageMin}</td>
                  <td>{labItemMeasure.ageMax}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.Gender.${labItemMeasure.gender}`} />
                  </td>
                  <td>{labItemMeasure.weightMin}</td>
                  <td>{labItemMeasure.weightMax}</td>
                  <td>{labItemMeasure.displayPrecision ? 'true' : 'false'}</td>
                  <td>{labItemMeasure.hiAbsolute}</td>
                  <td>{labItemMeasure.hiCritical}</td>
                  <td>{labItemMeasure.hiNormal}</td>
                  <td>{labItemMeasure.lowAbsolute}</td>
                  <td>{labItemMeasure.lowCritical}</td>
                  <td>{labItemMeasure.lowNormal}</td>
                  <td>{labItemMeasure.units}</td>
                  <td>{labItemMeasure.cursor}</td>
                  <td>{labItemMeasure.active ? 'true' : 'false'}</td>
                  <td>
                    {labItemMeasure.created ? <TextFormat type="date" value={labItemMeasure.created} format={APP_DATE_FORMAT} /> : null}
                  </td>
                  <td>{labItemMeasure.microSec}</td>
                  <td>{labItemMeasure.timestampentry}</td>
                  <td>{labItemMeasure.lastupdated}</td>
                  <td>
                    {labItemMeasure.testItem ? (
                      <Link to={`/lab-test-item/${labItemMeasure.testItem.id}`}>{labItemMeasure.testItem.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {labItemMeasure.diagLab ? <Link to={`/diag-lab/${labItemMeasure.diagLab.id}`}>{labItemMeasure.diagLab.id}</Link> : ''}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/lab-item-measure/${labItemMeasure.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/lab-item-measure/${labItemMeasure.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/lab-item-measure/${labItemMeasure.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.labItemMeasure.home.notFound">No Lab Item Measures found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={labItemMeasureList && labItemMeasureList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default LabItemMeasure;
